module.exports = __webpack_public_path__ + "img/ip-4.27203235.png";